import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
import Home from "./views/Home.vue";
import DashboardProtected from "@/views/dashboard/dashboard-protected.vue";
import Event from "@/views/event-page/index.vue";
import Campaigns from "@/views/campaigns/campaigns-page.vue";
import CampaignsPage from "@/views/campaigns/campaigns-page-wrapper.vue";
import CampaignEditWrapper from "@/views/campaigns/campaign-edit-wrapper.vue";
import SignIn from "@/views/SignIn.vue";
import resetPassword from "@/views/resetPassword.vue";
import Reminder from "@/views/reminder/reminder.vue";
import Donations from "@/views/donation/donation.vue";
import Teams from "@/views/teams/teams.vue";
import Gateways from "@/views/gateways/gatewaysList.vue";
import Account from "@/views/account/account.vue";
import User from "@/views/account/user.vue";
import EmailConfirm from "./views/EmailConfirm.vue";
import Users from "@/views/users/users.vue";
import DonorDashboard from "@/views/donor-dashboard/donor-dashboard.vue";
import DonorProfile from "@/views/donor-dashboard/donor-profile.vue";
import DonorDonations from "@/views/donor-dashboard/donor-donations.vue";
import DonorMyContacts from "@/views/donor-dashboard/my-contacts/index.vue";
import DonorMyContactList from "@/views/donor-dashboard/my-contacts/contact-list/contact-list.vue";
import DonorMyContact from "@/views/donor-dashboard/my-contacts/contact/contact.vue";
import DashboardMyContacts from "@/views/dashboard/my-contacts/index.vue";
import DashboardMyContactList from "@/views/dashboard/my-contacts/contact-list/contact-list.vue";
import DashboardMyContact from "@/views/dashboard/my-contacts/contact/contact.vue";
import DonorPayment from "@/views/donor-dashboard/donor-payment.vue";
import DonorHome from "@/views/donor-dashboard/sharedComponents/donor-home.vue";
import DonorSignUp from "@/views/donor-dashboard/donor-sign-up.vue";
import DonorTemporary from "@/views/donor-dashboard/donor-temporary.vue";
import DonorOrganization from "@/views/donor-dashboard/donor-organization.vue";
import DonorChooseAccount from "@/views/donor-dashboard/choose-account.vue";
import DonorMyTeams from "@/views/donor-dashboard/donor-my-teams.vue";
import DonorTeamInfoPage from "@/views/donor-dashboard/donor-team-info-page.vue";
import DonorSettings from "@/views/donor-dashboard/donor-settings.vue";
import DonorCommunicationPreferences from "@/views/donor-dashboard/donor-communication-preferences.vue";
import DonorCancelRecurringPlan from "@/views/donor-dashboard/donor-cancel-recurring-plan.vue";
import DonorTeamsPublicReply from "@/views/donor-dashboard/donor-teams-public-reply.vue";
import DonorAuctionCampaigns from "@/views/donor-dashboard/donor-auction-campaigns.vue";
import Emails from "@/views/emails/emails.vue";
import DesignTemplates from "@/views/design-templates/design-templates.vue";
import Payouts from "@/views/payouts/payoutsPage.vue";
import Billing from "@/views/billing/billingPage.vue";
import BillingWrapper from "@/views/billing/billingPageWrapper.vue";
import ReportsPage from "@/views/reports/ReportsPage.vue";
import CustomReportsPage from "@/views/reports/CustomReportsPage.vue";
import ToolsPage from "@/views/tools/ToolsPage.vue";
import MediaStoragePage from "@/views/media-storage/MediaStoragePage.vue";
import CharidyAppPage from "@/views/charidy-app/CharidyAppPage.vue";
import VideoTutorialsPage from "@/views/video-tutorials/page.vue";
import RDSPage from "@/views/recurring-donations-summary/rds-page.vue";
import OrgExternalDonorsPage from "@/views/org-external-donors/OrgExternalDonorsPage.vue";
import GoogleLookerStudioPage from "@/views/google-looker-studio/GoogleLookerStudioPage.vue";
import DonorPayoffRecurringPlan from "@/views/donor-dashboard/donor-payoff-recurring-plan.vue";
import DonorResubRecurringPlan from "@/views/donor-dashboard/donor-resub-recurring-plan.vue";
import CrowdedBankingPage from "@/views/crowded-banking/CrowdedBankingPage.vue";
import {
  forgetFreshSignIn,
  isFreshSignIn,
  leaveForChosenNewDashboard,
} from "@/helpers/new-dashboard-offer.js";

// const VendorLayout = () => import("@/views/vendor-dashboard/vendor-layout");
// const VendorDashboard = () => import("@/views/vendor-dashboard/dashboard/vendor-dashboard");
// const VendorGateways = () => import("@/views/vendor-dashboard/gateways/vendor-gateways");
// const Packages = () => import("@/views/vendor-dashboard/vendor-packages/packages-page");
// const PackagesPage = () =>
//   import("@/views/vendor-dashboard/vendor-packages/packages-page-wrapper.vue");
// const PackagesEdit = () =>
//   import("@/views/vendor-dashboard/vendor-packages/campaign-edit-vue/packagesEdit.vue");
// const VendorUsers = () => import("@/views/vendor-dashboard/users/users.vue");
// const profileTabs = () => import("@/views/vendor-dashboard/vendor-profiles/profileTabs.vue");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active-link",
  routes: [
    {
      path: "/",
      component: SignIn,
      name: "SignIn",
      meta: { SignIn: true },
    },
    {
      path: "/login/:token",
      component: SignIn,
      name: "SignInToken",
      meta: { SignIn: true },
    },
    {
      path: "/choose-account",
      name: "DonorChooseAccount",
      component: DonorChooseAccount,
    },
    {
      path: "/emailverify/:tokenVerify",
      component: EmailConfirm,
    },
    {
      path: "/register",
      beforeEnter() {
        window.location.href = "https://www.charidy.com/register";
      },
    },
    {
      path: "/resetpassword",
      component: resetPassword,
    },
    {
      path: "",
      component: Home,
      meta: { requiresLogin: true },
      children: [
        {
          path: "my-team-contacts",
          component: DashboardMyContacts,
          meta: { requiresLogin: true },
          children: [
            {
              path: "",
              component: DashboardMyContactList,
              name: "donor-my-team-contact-list",
              meta: { requiresLogin: true },
            },
            {
              path: ":id",
              component: DashboardMyContact,
              name: "donor-my-team-contact",
              meta: { requiresLogin: true },
            },
          ],
        },
        {
          path: "/dashboard",
          component: DashboardProtected,
          meta: { requiresLogin: true },
        },
        {
          path: "campaign",
          component: CampaignsPage,
          children: [
            {
              path: "",
              component: Campaigns,
              meta: { requiresLogin: true },
            },
            {
              path: ":id",
              component: CampaignEditWrapper,
              meta: { requiresLogin: true },
              beforeEnter(to, from, next) {
                store.commit("setSelectedCampaign", to.params.id);
                next();
              },
            },
          ],
          meta: { requiresLogin: true },
        },
        {
          path: "/event-donations",
          component: Event,
          meta: { requiresLogin: true, eventDonations: true },
        },
        {
          path: "/event-controls",
          component: Event,
          meta: { requiresLogin: true },
        },
        {
          path: "/leads/",
          component: Reminder,
          meta: { requiresLogin: true },
        },
        {
          path: "/emails/",
          component: Emails,
          meta: { requiresLogin: true },
        },
        {
          path: "/donations/",
          component: Donations,
          meta: { requiresLogin: true },
        },
        {
          path: "/teams/",
          component: Teams,
          meta: { requiresLogin: true },
        },
        {
          path: "/gateways",
          component: Gateways,
          meta: { requiresLogin: true },
        },
        {
          path: "/crowded/:section",
          name: "crowded-banking",
          component: CrowdedBankingPage,
          meta: { requiresLogin: true },
        },
        {
          path: "/billing",
          component: BillingWrapper,
          meta: { requiresLogin: true },
          children: [
            {
              path: "",
              component: Billing,
              meta: { requiresLogin: true },
            },
            {
              path: ":id",
              component: Payouts,
              meta: { requiresLogin: true },
            },
          ],
        },
        {
          path: "/account",
          component: Account,
          meta: { requiresLogin: true },
        },
        {
          path: "/user",
          component: User,
          meta: { requiresLogin: true },
        },
        {
          path: "/reports/recurring-donations-summary",
          component: RDSPage,
          meta: { requiresLogin: true },
          beforeEnter: (to, from, next) => {
            store.dispatch("updateOrgSettingsAccess").then(() => {
              if (store.state.account.canSeeReports) {
                next();
              } else {
                next({ path: "/dashboard" });
              }
            });
          },
        },
        {
          path: "/reports/custom",
          component: CustomReportsPage,
          meta: { requiresLogin: true },
          beforeEnter: (to, from, next) => {
            store.dispatch("updateOrgSettingsAccess").then(() => {
              if (store.state.account.canSeeReports) {
                next();
              } else {
                next({ path: "/dashboard" });
              }
            });
          },
        },
        {
          path: "/reports/:name",
          component: ReportsPage,
          meta: { requiresLogin: true },
          beforeEnter: (to, from, next) => {
            store.dispatch("updateOrgSettingsAccess").then(() => {
              if (store.state.account.canSeeReports) {
                next();
              } else {
                next({ path: "/dashboard" });
              }
            });
          },
        },
        {
          path: "/advanced/:page",
          name: "advanced",
          component: ToolsPage,
          meta: { requiresLogin: true },
        },
        {
          path: "/external-donors",
          name: "external-donors",
          component: OrgExternalDonorsPage,
          meta: { requiresLogin: true },
        },
        {
          path: "/looker-studio",
          name: "google-looker-studio",
          component: GoogleLookerStudioPage,
          meta: { requiresLogin: true },
        },
        {
          path: "/media-storage",
          name: "media-storage",
          component: MediaStoragePage,
          meta: { requiresLogin: true },
        },
        {
          path: "/charidy-app",
          name: "charidy-app",
          component: CharidyAppPage,
          meta: { requiresLogin: true },
        },
        {
          path: "/design-templates",
          component: DesignTemplates,
          meta: { requiresLogin: true },
          beforeEnter: (to, from, next) => {
            if (
              store.state.account.designTemplatesEnabled &&
              store.state.account.access.CanSeeDesignTemplates
            ) {
              next();
            } else {
              next({
                path: "/dashboard",
              });
            }
          },
        },
        {
          path: "/users",
          component: Users,
          meta: { requiresLogin: true },
        },
        {
          path: "/video-tutorials",
          component: VideoTutorialsPage,
          meta: { requiresLogin: true },
          beforeEnter: (to, from, next) => {
            store.dispatch("updateOrgSettingsAccess").then(() => {
              if (store.state.account.canSeeTrainingVideos) {
                next();
              } else {
                next({ path: "/dashboard" });
              }
            });
          },
        },
      ],
    },
    {
      path: "",
      component: DonorHome,
      children: [
        {
          path: "my-contacts",
          component: DonorMyContacts,
          meta: { requiresLogin: true, donorDashboard: true },
          children: [
            {
              path: "",
              component: DonorMyContactList,
              name: "donor-my-contact-list",
              meta: { requiresLogin: true, donorDashboard: true },
            },
            {
              path: ":id",
              component: DonorMyContact,
              name: "donor-my-contact",
              meta: { requiresLogin: true, donorDashboard: true },
            },
          ],
        },
        {
          path: "donor-my-teams",
          component: DonorMyTeams,
          meta: { requiresLogin: true, donorDashboard: true, donorMyTeams: true },
        },
        {
          path: "donor-my-teams/:id",
          component: DonorTeamInfoPage,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-dashboard",
          component: DonorDashboard,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-profile",
          component: DonorProfile,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-donations",
          component: DonorDonations,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-payment",
          component: DonorPayment,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-organization",
          component: DonorOrganization,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-settings",
          component: DonorSettings,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-communication-preferences",
          name: "donor-communication-preferences",
          component: DonorCommunicationPreferences,
          meta: { requiresLogin: true, donorDashboard: true },
        },
        {
          path: "donor-auction-campaigns",
          component: DonorAuctionCampaigns,
          meta: { requiresLogin: true, donorDashboard: true },
        },
      ],
    },
    {
      path: "/donor-cancel-recurring-plan/:jwtAuthCode",
      component: DonorCancelRecurringPlan,
      meta: { requiresLogin: false, donorDashboard: true },
    },
    {
      path: "/donor-payoff-recurring-plan/:jwtAuthCode",
      component: DonorPayoffRecurringPlan,
      meta: { requiresLogin: false, donorDashboard: true },
    },
    {
      path: "/donor-resub-recurring-plan/:jwtAuthCode",
      component: DonorResubRecurringPlan,
      meta: { requiresLogin: false, donorDashboard: true },
    },
    {
      path: "/donor-teams-public-reply/:jwtAuthCode",
      component: DonorTeamsPublicReply,
      meta: { requiresLogin: false, donorDashboard: true },
    },
    // {
    //   path: "",
    //   component: VendorLayout,
    //   children: [
    //     {
    //       path: "vendor-dashboard",
    //       component: VendorDashboard,
    //     },
    //     {
    //       path: "vendor-users",
    //       component: VendorUsers,
    //     },
    //     {
    //       path: "profile-tabs",
    //       component: profileTabs,
    //     },
    //     {
    //       path: "packages-page",
    //       component: PackagesPage,
    //       children: [
    //         {
    //           path: "",
    //           component: Packages,
    //           meta: { requiresLogin: true },
    //         },
    //         {
    //           path: ":id",
    //           component: PackagesEdit,
    //           meta: { requiresLogin: true },
    //         },
    //       ],
    //     },
    //     {
    //       path: "vendor-gateways",
    //       component: VendorGateways,
    //     },
    //   ],
    // },
    {
      path: "/donor-temporary",
      component: DonorTemporary,
    },
    {
      path: "/chooseaccount",
      component: DonorChooseAccount,
    },
    {
      path: "/donor-sign-up",
      component: DonorSignUp,
      name: "donors-sign-up",
      meta: { donorDashboard: true },
    },
    {
      path: "/donor-log-in",
      // component: DonorLogIn,
      // name: "donors-login",
      meta: { donorDashboard: true },
      redirect: "/",
    },
    {
      path: "/donor-log-in/:token",
      component: {
        created() {
          this.$store.dispatch("checkToken");
        },
        render() {
          return null; // This component does not render anything
        },
      },
      name: "donors-login-token",
      meta: { donorDashboard: true },
    },
    {
      path: "**",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta.donorMyTeams) &&
    !store.getters.isLoggedIn &&
    !(to.params?.token || to.query?.token)
  ) {
    next("/donor-log-in?redirect=" + to.fullPath);
  } else if (
    to.matched.some((record) => record.meta.requiresLogin) &&
    !store.getters.isLoggedIn &&
    !(to.params?.token || to.query?.token)
  ) {
    if (from.matched.some((record) => record.path.match("/donor-*"))) {
      next("/donor-log-in");
    } else {
      next("/?redirect=" + to.fullPath);
    }
  } else if (
    to.matched.some((record) => record.path.match("/donor-log-in")) &&
    store.getters.isLoggedIn &&
    !(to.params?.token || to.query?.token)
  ) {
    next("/donor-dashboard");
  } else {
    next();
  }
});

// Right after a sign-in (marked by the `setUser` mutation), the first page of
// either account tells where the person is going. An organization page gives
// way to the new dashboard when the organization chose it; a donor page stays,
// the new dashboard has none. Other pages (the sign-in, a registration step)
// keep the mark for the next one, as does a reload that cuts the check short.
router.beforeEach(async (to, from, next) => {
  const isDonorPage = to.matched.some((record) => record.meta.donorDashboard);
  const isOrgPage = !isDonorPage && to.matched.some((record) => record.meta.requiresLogin);
  if (!(isDonorPage || isOrgPage) || !isFreshSignIn()) {
    next();
    return;
  }

  const leaving = isOrgPage && (await leaveForChosenNewDashboard());
  forgetFreshSignIn();
  if (leaving) {
    // The page is going away. The navigation is left pending, not aborted:
    // callers would take an aborted one for a failed sign-in.
    return;
  }
  next();
});

export default router;
